/* OTB size guide: cm / inches switch (remembered), "Model" tag on the size the
   model wore, and highlight of the size the shopper has selected. */
(function () {
  if (window.otbSizeGuide) return;
  window.otbSizeGuide = true;

  function half(n) {
    var v = Math.round(n * 2) / 2;
    return (v % 1 === 0) ? String(v) : v.toFixed(1);
  }

  function norm(s) {
    return String(s || '').toUpperCase().replace(/\s+/g, '').replace(/[-–]/g, '/');
  }

  // A table row matches a size if the labels are the same, or the row is one half
  // of a paired size (XS/S) or the waist part of a waist/leg size (32 vs 32/30).
  function matches(rowLabel, size) {
    var r = norm(rowLabel), s = norm(size);
    if (!r || !s) return false;
    if (r === s) return true;
    var sp = s.split('/'), rp = r.split('/');
    if (/^\d+$/.test(rp[0]) && sp[0] === rp[0]) return true;
    if (rp.length > 1 && rp.indexOf(s) > -1) return true;
    return false;
  }

  function apply(root, unit) {
        root.querySelectorAll('[data-height-cm]').forEach(function (el) {
      el.textContent = unit === 'in' ? el.getAttribute('data-height-ft') : el.getAttribute('data-height-cm') + 'cm';
    });
    root.querySelectorAll('[data-cm]').forEach(function (el) {
      var cm = parseFloat(el.getAttribute('data-cm'));
      if (isNaN(cm)) return;
      el.textContent = unit === 'in' ? half(cm / 2.54) : el.getAttribute('data-cm');
    });
    root.querySelectorAll('[data-unit-label]').forEach(function (el) {
      el.textContent = unit === 'in' ? '"' : 'cm';
    });
    root.querySelectorAll('[data-otb-unit]').forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-otb-unit') === unit ? 'true' : 'false');
    });
    root.setAttribute('data-unit', unit);
  }

  // Only highlight a size once the shopper has picked one (the theme pre-selects
  // the first size on load, which isn't a real choice).
  var picked = /[?&]variant=/.test(location.search);

  function selectedValues() {
    var vals = [];
    if (!picked) return vals;
    document.querySelectorAll('variant-picker input[type=radio]:checked, variant-picker input[type=hidden][name^=option]').forEach(function (i) {
      vals.push(i.value);
    });
    return vals;
  }

  function mark(root) {
    var modelSizes = (root.getAttribute('data-model-sizes') || '').split('|').filter(Boolean);
    var selected = selectedValues();
    root.querySelectorAll('tbody tr[data-size]').forEach(function (tr) {
      var label = tr.getAttribute('data-size');
      var isModel = modelSizes.some(function (s) { return matches(label, s); });
      var isSel = selected.some(function (s) { return matches(label, s); });
      tr.classList.toggle('is-model', isModel);
      tr.classList.toggle('is-selected', isSel);
      var tag = tr.querySelector('.otb-sg__tag');
      if (tag) tag.hidden = !isModel;
    });
  }

  function saved() {
    try { return localStorage.getItem('otbSizeUnit'); } catch (e) { return null; }
  }

  function init() {
    document.querySelectorAll('.otb-sg').forEach(function (root) {
      if (!root.hasAttribute('data-unit')) {
        apply(root, saved() || root.getAttribute('data-default-unit') || 'cm');
      }
      mark(root);
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-otb-unit]');
    if (!btn) {
      if (e.target.closest('[aria-controls^="size-chart"]')) init();
      return;
    }
    var unit = btn.getAttribute('data-otb-unit');
    try { localStorage.setItem('otbSizeUnit', unit); } catch (err) {}
    document.querySelectorAll('.otb-sg').forEach(function (root) { apply(root, unit); });
  });

  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('variant-picker')) {
      picked = true;
      document.querySelectorAll('.otb-sg').forEach(mark);
    }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();